import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "primereact/dropdown";

import {
  getBranches,
  GetBusinessesList,
} from "../../store/slices/BusinessSlice";
import i18next from "i18next";
import SharedButton from "../../components/Shared/SharedButton";
import { AutoComplete } from "primereact/autocomplete";
import { fetchData } from "../../helpers/fetchData";
import moment from "moment";
import validSupergitHIS from "../../api/validSupergitHIS";
import DatePicker from "../../components/Shared/DatePicker";
import DropdownComponent from "../../components/Shared/DropdownComponent";

const Filters = ({
  filters,
  setFilters,
  handleAddFilters,
  filterLoading,
  filteredInvoices,
  fetchListData,
  setSearchText,
  loading,
  storageKey = "",
}) => {
  const { t } = useTranslation();
  const lang = i18next.language;
  const dispatch = useDispatch();
  const { branches } = useSelector((state) => state.business);
  const [tpaList, setTpaList] = useState([]);
  const [buisnessList, setBuisnessList] = useState([]);
  const { businessList } = useSelector((state) => state.business);
  const [customers, setCustomers] = useState([]);
  const currentDate = moment().format("YYYY-MM-DD");
  const firstDayOfCurrentMonth = moment().startOf("month").format("YYYY-MM-DD");
  const listBranchvalues = branches?.data
    ? Object.entries(branches?.data).map(([id, branch]) => ({
        value: Number(branch?.id),
        label: lang === "ar" ? branch.name_ar : branch.name_en,
      }))
    : [];

  const listCompaniesvalues = buisnessList?.data
    ? Object.entries(businessList?.data).map(([id, company]) => ({
        value: Number(company?.id),
        label: lang === "ar" ? company.name_ar : company.name_en,
      }))
    : [];

  const payment_method_values = [
    { value: "cash", label: lang === "ar" ? "نقدي" : "Cash" },
    { value: "bank", label: lang === "ar" ? "بنك" : "Bank" },
    { value: "mada", label: lang === "ar" ? "مدى" : "MADA" },
    { value: "cheque", label: lang === "ar" ? "يفحص" : "Cheque" },
  ];

  useEffect(() => {
    dispatch(GetBusinessesList({ page: 1, per_page: 100 }));
    dispatch(getBranches());
  }, []);

  const handleComplete = (event) => {
    fetchCustomers(event.query);
  };

  const fetchCustomers = async (query) => {
    let payload = { query };
    const data = await fetchData("POST", "searchCustomer", payload);
    if (data) {
      const listAccountsValues = data?.data
        ? Object.entries(data?.data).map(([id, customer]) => ({
            value: Number(customer?.id),
            label: customer?.name + " " + customer?.secondary_contact_number,
          }))
        : [];
      setCustomers(listAccountsValues);
    }
  };
  const getTpaList = async () => {
    try {
      const res = await validSupergitHIS.post("getTpa");
      if (res.data) {
        setTpaList(res?.data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const getBuisnessList = async (id) => {
    try {
      const res = await validSupergitHIS.post(`companiesByTPA/${id}`);
      if (res.data) {
        setBuisnessList(res?.data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (storageKey && localStorage.getItem(storageKey)) {
      let payload = JSON.parse(localStorage.getItem(storageKey));
      if (payload?.tpa) {
        getBuisnessList(payload?.tpa);
      }
    }
  }, [storageKey]);

  const handleResetFilters = () => {
    let payload = {
      start_date: firstDayOfCurrentMonth,
      end_date: currentDate,
      branch_id: "",
      insurance_company_id: "",
      query: "",
      page: 1,
      per_page: 10,
    };
    if (storageKey) localStorage.setItem(storageKey, JSON.stringify(payload));
    setSearchText("");
    setFilters(payload);
    fetchListData(payload);
  };

  useEffect(() => {
    getTpaList();
  }, []);

  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center mb-2 gap-2">

        <DatePicker
          useFormik={false}
          // label={t("StartDate")}
          value={filters?.start_date ? new Date(filters.start_date) : null}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              start_date: e.value
                ? new Date(
                    e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                  )
                    .toISOString()
                    .split("T")[0]
                : "",
            }))
          }
        />
        <DatePicker
          useFormik={false}
          // label={t("EndDate")}
          value={filters?.end_date ? new Date(filters.end_date) : null}
          onChange={(e) =>
            setFilters((prev) => ({
              ...prev,
              end_date: e.value
                ? new Date(
                    e.value.getTime() - e.value.getTimezoneOffset() * 60000,
                  )
                    .toISOString()
                    .split("T")[0]
                : "",
            }))
          }
        />
        <DropdownComponent
          useFormik={false}
          // label={t("tpa")}
          value={filters?.tpa}
          options={tpaList?.map((item) => ({
            label: item?.name_en,
            value: Number(item?.id),
          }))}
          handleChange={(e) => {
            setFilters((prev) => ({ ...prev, tpa: e.value }));
            getBuisnessList(e.value);
          }}
          placeholder={t("tpa")}
          showClear
        />
        <DropdownComponent
          useFormik={false}
          // label={t("select_company")}
          value={filters?.insurance_company_id}
          options={buisnessList?.map((item) => ({
            label: `${item?.name_en} (${item?.short_name})`,
            value: item?.id,
          }))}
          handleChange={(e) =>
            setFilters((prev) => ({ ...prev, insurance_company_id: e.value }))
          }
          placeholder={t("select_company")}
          showClear
        />
        <DropdownComponent
          useFormik={false}
          // label={t("select_branch")}
          value={filters?.branch_id}
            options={[
              {
                label: "Select All",
                value: "All",
              },
              ,
              ...listBranchvalues,
            ]}          handleChange={(e) =>
            setFilters((prev) => ({ ...prev, branch_id: e.value }))
          }
          placeholder={`${t("select")} ${t("branch")}`}
          showClear
        />
        <div className="flex gap-2 items-center">
          <SharedButton
            disabled={loading}
            title={t("apply_filters")}
            icon="pi pi-filter"
            onClick={() => {
              if (storageKey) {
                localStorage.setItem(storageKey, JSON.stringify(filters));
              }
              fetchListData(filters);
            }}
          />
          <SharedButton
          buttonType="reset"
            disabled={filterLoading}
            title={t("reset")}
            icon="pi pi-sync"
            onClick={handleResetFilters}
          />
        </div>
      </div>
    </div>
  );
};

export default Filters;
